module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "elmenu"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.defaultElmenu,
      "unique-opened": true,
      "theme": "dark",
      "router": true
    }
  }, [_vm._l((_vm.elmenu), function(item) {
    return [(item.child) ? [_c('el-submenu', {
      attrs: {
        "index": item.url
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "el-icon-menu"
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.child), function(childitem) {
      return [_c('el-menu-item', {
        attrs: {
          "index": childitem.url
        }
      }, [_vm._v(_vm._s(childitem.name))])]
    })], 2)] : [_c('el-menu-item', {
      attrs: {
        "index": item.url
      }
    }, [_vm._v(_vm._s(item.name))])]]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1496a967"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inavmenu/elmenu.vue
// module id = 754
// module chunks = 6